import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/purchase-management/returns-list`;

export const returnsListRoutesObj = {
  list: baseRoute,
  restoreGoods: `${baseRoute}/restore-goods/:purchaseInvoiceId/:returnId`,
} as const;

export type IReturnsListRouteParams = IExtractRouteParamMap<
  typeof returnsListRoutesObj
>;

export const purchaseReturnsListPath = createPaths<
  typeof returnsListRoutesObj,
  IReturnsListRouteParams
>(returnsListRoutesObj);
